// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1A1fo","large":"styles_large__PjZdr"};